import { ErrorMessage, FieldTextV6, FormRow, Icon } from '@tallink/components-lib'
import { mediaQueries } from '@tallink/components-lib/src/constants/media'
import classNames from 'classnames'
import PropTypes from 'prop-types'
import React from 'react'
import { useForm } from 'react-hook-form'
import { useTranslation } from 'react-i18next'
import { useMedia } from 'react-use'

import SerialTicketsClient from '../../../clients/SerialTicketsClient'
import Button from '../../common/Button'
import s from './AddNewVoucher.module.scss'

export default function AddNewVoucher({ onAddVoucher, onCancelAddNewVoucher }) {
  const { t } = useTranslation()
  const smUp = useMedia(mediaQueries.smUp)
  const {
    clearErrors,
    errors,
    formState: { isSubmitting, isValid },
    handleSubmit,
    register,
    reset,
    setError,
    setValue,
    watch
  } = useForm({ mode: 'onChange' })
  const voucherInputValue = watch('voucher')
  const addVoucherButtonClass = smUp ? 'button-default-sm' : 'button-primary-sm'

  return (
    <form className={s['add-voucher-form']} onSubmit={handleSubmit(onSubmit)}>
      <button className={s.remove} onClick={onCancelAddNewVoucher}>
        <Icon size="xs" type="cross" />
      </button>
      <div className={s.voucher}>
        <FormRow
          error={<ErrorMessage message={t(`voucherPanel.voucher.validate.${errors.validation?.type}`)} />}
          invalid={!isValid}
          label={t('voucherPanel.voucher.label')}
        >
          <FieldTextV6
            disabled={isSubmitting}
            inputRef={register}
            invalid={errors.validation?.type === 'error'}
            name="voucher"
            onChange={e => {
              setValue('voucher', e.target.value)
              clearErrors()
            }}
            onClearClick={() => reset()}
            size={smUp ? 's' : ''}
          />
        </FormRow>
      </div>
      <Button
        className={classNames(addVoucherButtonClass, s['add-button'])}
        disabled={!voucherInputValue || !!errors.validation || isSubmitting}
        processing={isSubmitting}
      >
        {t('voucherPanel.voucher.button.add')}
      </Button>
      {!smUp && (
        <Button onClick={onCancelAddNewVoucher} type="reset">
          {t('common.cancel')}
        </Button>
      )}
    </form>
  )

  async function onSubmit({ voucher }) {
    const voucherInfo = await SerialTicketsClient.getVoucherInfo(voucher)

    if (voucherInfo.valid && !voucherInfo.callToCallCenter) {
      onAddVoucher(voucherInfo)
    } else {
      setError('validation', { type: voucherInfo.callToCallCenter ? 'callToCallCenter' : 'error' })
    }
  }
}

AddNewVoucher.propTypes = {
  onAddVoucher: PropTypes.func.isRequired,
  onCancelAddNewVoucher: PropTypes.func.isRequired
}
